import { OPERATION_MODE } from "@/common/constants";
import { OperationsModes } from "@/common/fields/operations-modes";

// Solo estos modos guardan colores por tenant.
const STACK_COLORS_MODES = [
    OperationsModes.multiTenant,
    OperationsModes.ecommercePro
];

export const isStackColorsMode = (operationMode = OPERATION_MODE) =>
    STACK_COLORS_MODES.includes(operationMode);

const STACK_KEYS = ["primary", "secondary", "emphasis", "details"];

const HEX_COLOR = /^#[0-9a-fA-F]{3,8}$/;

export function applyTenantStackColors(stackColors) {
    if (!stackColors) return;
    STACK_KEYS.forEach((key) => {
        const value = stackColors[key];
        if (!HEX_COLOR.test(value ?? "")) return;
        document.documentElement.style.setProperty(
            `--color-stack-${key}`,
            value
        );
    });
}
